angular.module('picmonicng').controller('PathwaysPicmonicsController', [
  '$scope',
  '$state',
  '$browseStateParams',
  '$sce',
  'Tracks',
  'PlaylistService',
  'UserService',
  '$filter',
  '$modal',
  'MarketOptionsConfig',
  'FacebookService',
  '$cookies',
  '$location',
  'BrowseService',
  '$rootScope',
  'MetaService',
  'MarketSelectorModalService',
  '$anchorScroll',
  'ReferralResource',
  'ReferralDataService',
  '$stateParams',
  '$q',
  'MetatagResource',
  'SplitTestService',
  function (
    $scope,
    $state,
    $browseStateParams,
    $sce,
    Tracks,
    PlaylistService,
    UserService,
    $filter,
    $modal,
    MarketOptionsConfig,
    FacebookService,
    $cookies,
    $location,
    BrowseService,
    $rootScope,
    MetaService,
    MarketSelectorModalService,
    $anchorScroll,
    ReferralResource,
    ReferralDataService,
    $stateParams,
    $q,
    MetatagResource
  ) {
    $scope.$sce = $sce;
    $scope.UserService = UserService;
    $scope.BrowseService = BrowseService;
    $scope.$anchorScroll = $anchorScroll;
    $scope.ReferralDataService = ReferralDataService;
    $scope.user_count = window.pls_config.user_count;
    $scope.metatags = {};

    var track_slug = String($browseStateParams.track_id ? $browseStateParams.track_id : $stateParams.track_id).split(
      '-'
    );
    var track_id = track_slug[track_slug.length - 1];

    var pathway_slug = String(
      $browseStateParams.pathway_id ? $browseStateParams.pathway_id : $stateParams.pathway_id
    ).split('-');
    var pathway_id = pathway_slug[pathway_slug.length - 1];

    // Build breadcrumb urls
    var parts = $location.$$path.split('/');
    $scope.breadcrumbs = [$location.$$protocol + '://' + $location.$$host + $location.$$path];
    for (i = 0; i < 4; i++) {
      parts.pop();
      $scope.breadcrumbs.unshift($location.$$protocol + '://' + $location.$$host + parts.join('/'));
    }

    $scope.loadingTrack = true;
    $scope.loadingPicmonics = true;
    $scope.$state = $state;
    $scope.onBooks = false;

    if (UserService.user.user_id && $state.current.name.indexOf('app.pathways') > -1) {
      var params = {
        market: $stateParams.market,
        curriculum: $stateParams.curriculum,
        pathway_id: $stateParams.pathway_id,
        track_id: $stateParams.track_id,
      };
      $location.url(
        '/home' +
          '?browse=' +
          $state.current.name +
          '&browseParams=' +
          JSON.stringify(params) +
          '&browseOptions=' +
          JSON.stringify({ open: true })
      );
    }

    MetatagResource.get({ url: $location.$$path }, function (data) {
      $scope.metatags = data;

      if (data.h1) {
        $scope.replaceH1 = data.h1;
      }

      if (data.h2) {
        $scope.replaceH2 = data.h2;
      }

      if (data.title) {
        MetaService.replace('%PATHWAY%', data.title);
      } else {
        MetaService.replace('%PATHWAY%', 'Pathways');
      }
    });

    if ($state.current.name.indexOf('books') > -1) {
      $scope.onBooks = true;
    }

    //Scroll past copy on public picmonics when navigating from public pathways
    if ($location.search().scroll_to == 'content') {
      $anchorScroll('public-picmonics-content');
    }

    $scope.currentMarket = $scope.market = MarketOptionsConfig.getMarketBySlug(
      $browseStateParams.market ? $browseStateParams.market : $stateParams.market
    );

    if ($scope.currentMarket && $scope.currentMarket.is_pseudo) {
      UserService.setMarketCookies($scope.currentMarket.id);
    }

    $scope.getTrack = function () {
      $scope.loadingTrack = true;
      var trackPromise = Tracks.get({ track_id: track_id }, function (track) {
        $scope.trackInfo = track;
        $scope.loadingTrack = false;
        $scope.pathway = {
          market_id: track.root_market_id,
          pathway_id: track.root_pathway_id,
          curriculum: track.root_pathway_curriculum,
          pathway_type: track.root_pathway_pathway_type,
          name: track.root_pathway_name,
        };
      });

      $scope.loadingPicmonics = true;
      var picmonicPromise = Tracks.get(
        { track_id: track_id, resource: 'picmonics' },
        function (track) {
          for (var a in track.cards) {
            var count = 0;
            var facts = $filter('orderBy')(track.cards[a].facts, ['order', 'fact_id']);
            for (var b in facts) {
              if (!facts[b].header) {
                facts[b].display_order = count;
                count++;
              }
            }

            track.cards[a].facts = facts;
          }

          $scope.track = track;
          $scope.loadingPicmonics = false;
        },
        function () {
          $state.transitionTo('app.404');
        }
      );

      return $q.all([trackPromise.$promise, picmonicPromise.$promise]);
    };

    $scope.getTrack().then(function () {
      if (!BrowseService.browseOpen) {
        if ($scope.metatags.title) {
          MetaService.replace('%PATHWAY%', $scope.metatags.title);
        } else {
          MetaService.replace('%PATHWAY%', $scope.track.name + ' - ' + $scope.trackInfo.root_pathway_name);
        }

        MetaService.replace(
          '%DESCRIPTION%',
          'Learn ' +
            $scope.track.name +
            ' - ' +
            $scope.trackInfo.root_pathway_name +
            " faster and easier with Picmonic's unforgettable images and stories! Picmonic is research proven to increase your memory retention and test scores. Start learning today for free!"
        );
        MetaService.replace('%MARKET%', $scope.currentMarket.name);

        if ($stateParams.register) {
          $scope.register(false);
        }
      }
    });

    var onChange = function (event, data) {
      if (data.action === 'quiz_attempt') {
        $scope.getTrack();
      }
    };
    $scope.$on('cardDataChanged', onChange);

    $scope.register = function () {
      UserService.showRegisterModal(false, null, null, null, $scope.currentMarket.id);
    };
  },
]);
